import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { MS_LOCATION_CONFIG } from 'settings/address-location';

class InternationalAddressService extends EntityApiService<any> {
  searchCountries = async (params?: any, config?: RequestConfig): Promise<any> => {
    const q: string = params?.search || '';
    delete params?.search;

    return await this.handleSearchResponse(
      ApiClientService.get(this.getPath(`/international-addresses/countries?q=${q}`), { ...params, q }),
      params?.size || 10,
    );
  };

  getOneCountry = async (country?: string, config?: RequestConfig): Promise<any> => {
    if (!country) {
      return await new Promise((resolve, reject) => {
        reject({ error: 'Country is required' });
      });
    }

    return await this.handleResponse(
      ApiClientService.get(this.getPath(`/international-addresses/countries/${country}`), {}),
    );
  };

  searchStates = async (params?: any, config?: RequestConfig): Promise<any> => {
    const q: string = params?.search || '';
    delete params?.search;

    return await this.handleSearchResponse(
      // @ts-ignore
      ApiClientService.get(
        this.getPath(`/international-addresses/countries/${params?.country as string}/states?q=${q}`),
        {
          ...params,
          q,
        },
      ),
      params?.size || 10,
    );
  };

  getOneState = async (country?: string, state?: string, config?: RequestConfig): Promise<any> => {
    if (!country || !state) {
      return await new Promise((resolve, reject) => {
        resolve({ data: [] });
      });
    }

    return await this.handleResponse(
      ApiClientService.get(this.getPath(`/international-addresses/countries/${country}/states/${state}`), {}),
    );
  };
}

export default new InternationalAddressService(MS_LOCATION_CONFIG.url);
